<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ApolloQuery
        :query="allowanceRecipientsQuery"
        :variables="{
          pageSize: $options.pageSize,
          cursor: null,
          orderBy: $options.orderBy
        }"
        :notifyOnNetworkStatusChange="false"
      >
        <template v-slot="{ result: { data, fullData }, query }">
          <div v-if="fullData && fullData.errors" class="error apollo">
            <ul>
              <li v-for="error in fullData.errors" :key="error.path.join(':')" class="md-layout-item">
                {{ unauthenticated(error) ? reAuthMessage : error.message }}
              </li>
            </ul>
          </div>
          <div v-if="data && data.allowanceRecipients && data.allowanceRecipients.edges">
            <form enctype="multipart/form-data" novalidate>
              <p>
                <label for="file-input">Upload a CSV file to update list:</label>
              </p>
              <input
                type="file"
                ref="fileinput"
                id="file-input"
                :disabled="isUploading"
                @change="filesChange($event.target.files, query)"
                accept=".csv"
              >
              <p v-if="isUploading">
                Uploading file...
              </p>
            </form>
            <md-card :class="{ dimmed: isUploading }">
              <md-card-header class="md-card-header-icon md-card-header-green">
                <div class="card-icon">
                  <md-icon>assignment_ind</md-icon>
                </div>
                <h4 class="title">Allowance Recipients</h4>
              </md-card-header>
              <md-card-content>
                <md-table
                  id="allowanceRecipientsTable"
                  :value="data.allowanceRecipients.edges"
                  class="paginated-table table-striped table-hover"
                >
                  <md-table-row
                    slot="md-table-row"
                    slot-scope="{ item: { node } }"
                    md-selectable="single"
                  >
                    <md-table-cell md-label="Email">
                      {{ node.email }}
                    </md-table-cell>
                    <md-table-cell />
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>

            <md-button
              class="md-info"
              v-if="data.allowanceRecipients.pageInfo.hasNextPage"
              :disabled="isLoadingMore"
              @click="loadMore(query, data.allowanceRecipients.pageInfo.endCursor)"
            >
              Load more
            </md-button>
          </div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>

<script>
import { AllowanceRecipientsQuery } from "@/graphql.js";
import { Badge } from "@/components";
import Swal from "sweetalert2";

export default {
  name: "AllowanceRecipients",
  components: { Badge },
  pageSize: 500,
  orderBy: { email: 'asc' },
  data() {
    return {
      isLoadingMore: false,
      isUploading: false,
      reAuthMessage: (
        "You're session expired."
        + " We should prioritize shortcut story 3444"
        + " to get automatic re-authentication working with graphql."
      ),
    }
  },
  methods: {
    allowanceRecipientsQuery() {
      return AllowanceRecipientsQuery;
    },
    async loadMore(query, endCursor) {
      this.isLoadingMore = true;
      try {
        await query.fetchMore({
          variables: { cursor: endCursor },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const newEdges = fetchMoreResult.allowanceRecipients.edges;
            const pageInfo = fetchMoreResult.allowanceRecipients.pageInfo;

            return newEdges.length ? {
              ...previousResult,
              allowanceRecipients: {
                ...previousResult.allowanceRecipients,
                edges: [...previousResult.allowanceRecipients.edges, ...newEdges],
                pageInfo,
              }
            } : previousResult
          },
        })
      } catch (e) {
        if (e.graphQLErrors.some(this.unauthenticated)) {
          alert(this.reAuthMessage);
        } else {
          alert(e);
        }
      } finally {
        this.isLoadingMore = false;
      }
    },
    unauthenticated(error) {
      return error.extensions && error.extensions.code === "UNAUTHENTICATED";
    },
    filesChange(fileList, query) {
      const file = fileList[fileList.length - 1];
      if (file) {
        this.isUploading = true;
        Swal.fire({
          title: "Update list from CSV file?",
          text: "This will overwrite the existing list",
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success",
          cancelButtonClass: "md-button md-danger",
          confirmButtonText: "Yes, update",
          buttonsStyling: false
        }).then(async (result) => {
          if (result.value) {
            const url = "/v2/admins/allowance_recipient_list";
            const formData = new FormData();
            formData.append("allowance_recipient_list", file, file.name);
            await this.$http.secured.put(url, formData)
            .then(response => {
              query.refetch();
              Swal.fire({
                title: "Updated",
                text: "List updated",
                type: "success",
                confirmButtonClass: "md-button md-success",
                buttonsStyling: false
              })
            });
          }
        })
        .catch(error => {
          const meta = error.response.data.meta
          alert((meta && meta.message) || error)
        })
        .finally(() => {
          this.isUploading = false
          this.$refs.fileinput.value = null;
        });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
form {
  padding-bottom: 30px;
}
.dimmed {
  opacity: .26;
}
</style>
